import React, { useEffect } from 'react';
import { ActionModal } from 'br2s-ui-componentlibrary_r2_02';
import { NO_SWITCH_PROFILE_MODAl } from '@/utilities/constants';

interface NoProfileSwitchModalProps {
  isOpen: boolean;
  onClick: () => void;
  onCloseClick: () => void;
}

const NoProfileSwitchModal = ({
  isOpen,
  onClick,
  onCloseClick,
}: NoProfileSwitchModalProps) => {
  useEffect(() => {
    if (!isOpen) {
      document.body.style.overflow = 'unset';
    }
  }, [isOpen]);

  return (
    <ActionModal
      id="header-modal"
      isOpen={isOpen}
      title={NO_SWITCH_PROFILE_MODAl.TITLE}
      message={NO_SWITCH_PROFILE_MODAl.DESCRIPTION}
      state="warning"
      actionButton2={{
        id: 'profile-ok',
        type: 'primary',
        label: NO_SWITCH_PROFILE_MODAl.BUTTON_LABEL,
        onClick,
      }}
      onCloseClick={onCloseClick}
    />
  );
};

export default NoProfileSwitchModal;
